import { AgendaModel } from "@/models/cadastros/saude/AgendaModel";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { BloqueioDesbloqueioAgendaPrestadorDTO } from "./cadastro/saude/agenda/BloqueioDesbloqueioAgendaPrestadorDTO";
import { BloqueioDesbloqueioAgendaProfissionalDTO } from "./cadastro/saude/agenda/BloqueioDesbloqueioAgendaProfissionalDTO";
import { ConfiguracaoAgendaPrestadorPagedResultDTO } from "./cadastro/saude/ConfiguracaoAgendaPrestadorPagedResultDTO";
import { FiltroAgendaPrestadorDTO } from "./cadastro/saude/FiltroAgendaPrestadorDTO";
import { HorariosDisponiveisDTO } from "./cadastro/saude/HorariosDisponiveisDTO";
import { VisualizacaoAgendaDTO } from "./cadastro/saude/VisualizacaoAgendaDTO";
import { servicosSaudeApiConfig } from "./config";

class ServicosSaudeAgendaApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  salvarAgendaProfissional(cadastroAgenda: AgendaModel) {
    return this.post<EspecialidadeModel>("/agenda/profissional", cadastroAgenda)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  salvarAgendaEspecialidade(cadastroAgenda: AgendaModel) {
    return this.post<AgendaModel>("/agenda/prestador", cadastroAgenda)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        if (
          error.response?.status === 400 &&
          error.response?.data.detail ===
            "Existe um ou mais profissionais que atende especialidade selecionada, por favor efetue a configuração da agenda através do profissional."
        ) {
          throw new Error(error.response?.data.detail);
        }
        throw new Error(`Ocorreu uma falha ao cadastrar a agenda da especialidade para o prestador`);
      });
  }

  atualizarAgendaProfissional(cadastroAgenda: AgendaModel) {
    return this.put<AgendaModel>(`/agenda/profissional/${cadastroAgenda.id}`, cadastroAgenda)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  atualizarAgendaEspecialidade(cadastroAgenda: AgendaModel) {
    return this.put<AgendaModel>(`/agenda/prestador/${cadastroAgenda.id}`, cadastroAgenda)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  consultarAgendaPrestador(
    filtroAgendaPrestadorDTO: FiltroAgendaPrestadorDTO
  ): Promise<ConfiguracaoAgendaPrestadorPagedResultDTO> {
    return this.get<FiltroAgendaPrestadorDTO>("/agenda/prestador", {
      params: filtroAgendaPrestadorDTO,
    })
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao pesqusiar configurações de agenda");
      });
  }

  consultarAgendaProfissional(
    filtroAgendaPrestadorDTO: FiltroAgendaPrestadorDTO
  ): Promise<ConfiguracaoAgendaPrestadorPagedResultDTO> {
    return this.get<FiltroAgendaPrestadorDTO>("/agenda/profissional", {
      params: filtroAgendaPrestadorDTO,
    })
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao pesqusiar configurações de agenda");
      });
  }

  obterConfiguracaoAgendaPrestador(idConfiguracaoAgendaPrestador: number): Promise<AgendaModel> {
    return this.get<AgendaModel>(`/agenda/prestador/${idConfiguracaoAgendaPrestador}`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao obter configuração de agenda");
      });
  }

  obterConfiguracaoAgendaProfissional(idConfiguracaoAgendaProfissional: number): Promise<AgendaModel> {
    return this.get<AgendaModel>(`/agenda/profissional/${idConfiguracaoAgendaProfissional}`)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao obter configuração de agenda");
      });
  }

  excluirConfiguracaoAgendPrestadorEspecialidade(idConfiguracaoAgenda: number) {
    return this.delete(`/agenda/prestador/${idConfiguracaoAgenda}`).catch(() => {
      throw new Error("Falha ao excluir a configuração de agenda do prestador");
    });
  }

  excluirConfiguracaoAgendaProfissional(idConfiguracaoAgenda: number) {
    return this.delete(`/agenda/profissional/${idConfiguracaoAgenda}`).catch(() => {
      throw new Error("Falha ao excluir a configuração de agenda do profissional");
    });
  }

  obterHorariosDisponiveisPrestadorEspecialidade(
    visualizacaoAgendaDTO: VisualizacaoAgendaDTO
  ): Promise<HorariosDisponiveisDTO[]> {
    return this.get<HorariosDisponiveisDTO[]>(`/agenda/prestador/${visualizacaoAgendaDTO.idPrestador}/data`, {
      params: visualizacaoAgendaDTO,
    })
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao obter visualização da agenda");
      });
  }

  obterHorariosDisponiveisProfissional(visualizacaoAgendaDTO: VisualizacaoAgendaDTO): Promise<HorariosDisponiveisDTO[]> {
    return this.get<HorariosDisponiveisDTO[]>(`/agenda/profissional/${visualizacaoAgendaDTO.idProfissional}/data`, {
      params: visualizacaoAgendaDTO,
    })
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao obter visualização da agenda");
      });
  }

  bloquearAgendaPrestador(bloquearAgendaPrestador: BloqueioDesbloqueioAgendaPrestadorDTO): Promise<any> {
    return this.post<BloqueioDesbloqueioAgendaPrestadorDTO>("/agenda/prestador/bloquear", bloquearAgendaPrestador)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao efetuar o bloqueio da agenda do prestador");
      });
  }

  desbloquearAgendaPrestador(desbloquearAgendaPrestador: BloqueioDesbloqueioAgendaPrestadorDTO): Promise<any> {
    return this.post<BloqueioDesbloqueioAgendaPrestadorDTO>("/agenda/prestador/desbloquear", desbloquearAgendaPrestador)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao efetuar o desbloqueio da agenda do prestador");
      });
  }

  bloquearAgendaProfissional(bloquearAgendaProfissional: BloqueioDesbloqueioAgendaProfissionalDTO): Promise<any> {
    return this.post<BloqueioDesbloqueioAgendaPrestadorDTO>("/agenda/profissional/bloquear", bloquearAgendaProfissional)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao efetuar o bloqueio da agenda do profissional");
      });
  }

  desbloquearAgendaProfissional(desbloquearAgendaProfissional: BloqueioDesbloqueioAgendaProfissionalDTO) {
    return this.post<BloqueioDesbloqueioAgendaPrestadorDTO>("/agenda/profissional/desbloquear", desbloquearAgendaProfissional)
      .then((res: AxiosResponse) => {
        const { data } = res;
        return data;
      })
      .catch((err: AxiosError) => {
        throw new Error("Falha ao efetuar o desbloqueio da agenda do profissional");
      });
  }
}

export const servicosSaudeAgendaApi = new ServicosSaudeAgendaApi(servicosSaudeApiConfig);
